import $ from 'jquery';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import useApiUrl from '../../framework/hooks/useApiUrlHook';

/**
 *
 * @param pro
 * @param cases
 * @param limit
 * @returns {JSX.Element}
 * @constructor
 *
 * Usage example: <CaseSlider pro cases{[23, 1, 9]} limit={10} />
 */

export default function CaseSlider({ pro = false, cases = [], limit = 5 }) {
    const apiUrl = useApiUrl();
    const [caseResults, setCaseResults] = useState([]);

    const getCases = () => {
        const url = `${apiUrl}/case/slider/${JSON.stringify(cases)}/${limit}`;
        axios
            .get(url)
            .then((response) => {
                setCaseResults(response.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        if (apiUrl != null) getCases();
    }, [apiUrl]);

    return (
        <div className={`case-slider-active sections section-w logo-light ${pro ? 'pro-case-slider-active' : ''}`}>
            <Swiper
                speed={1000}
                spaceBetween={50}
                slidesPerView={1}
                modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                loop
                autoplay={{ delay: 3000 }}
                pagination={{ el: '.case-pagination', clickable: true, dynamicBullets: false }}
                navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
            >
                {caseResults?.map((c) => (
                    <SwiperSlide key={c.id}>
                        <div
                            className="case-slide-wrap"
                            style={{
                                backgroundImage: `url(${apiUrl}/img/extern/ratio/www.bandwerk.nl/klanten_sfeer_2023/2425/1805/100/${c.image})`,
                            }}
                        >
                            <div className="case-content-wrapper">
                                <h2>{c.klant}</h2>
                                <a href={`/succesverhalen/${c.fancy_name}`}>
                                    <h3>{c.titel}</h3>
                                </a>
                                <div className="case-tags">
                                    {c?.diensten?.map((dienst, index) => (
                                        <a key={index} href={`/onze-diensten/${dienst.url}`}>
                                            {dienst.titel}
                                        </a>
                                    ))}
                                </div>
                                <a className={"caseButton"} href={`/succesverhalen/${c.fancy_name}`}><img src={`/assets/img/shape/cursor-1.svg`} alt="Bekijk case" /></a>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            {/* If we need pagination */}
            <div className="swiper-pagination case-pagination" />
        </div>
    );
}
